<template>
  <div>
    <v-dialog
      v-model="showConfirmDialog"
      max-width="420px"
    >
      <v-card>
        <v-card-title>Это окончательное решение?</v-card-title>

        <v-card-text>
          Решение: <span class="font-weight-bold">{{ cardText }}</span>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="secondary"
            @click="showConfirmDialog = false"
          >Нет</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="handle(chosenType)"
          >Да</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card flat>
      <v-card-title>Управление заявкой</v-card-title>
      <v-card-text
      >У этой заявки было найдено несколько похожих, продолжить?
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="toggleProcess('stop', true)">Дубль</v-btn>
        <v-spacer/>
        <v-btn color="primary" @click="toggleProcess('next', true)">Продолжить</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import StatusChip from "@/components/common/StatusChip";

export default {
  name: "AppHandle",

  components: {
    StatusChip,
  },

  data() {
    return {
      showConfirmDialog: false,
      chosenType: ''
    };
  },

  methods: {
    ...mapActions("app", ["appTouch", "appInfo"]),

    handle(type) {
      this.appTouch({
        handleType: type
      }).then(() => {
        this.showConfirmDialog = false;
        this.appInfo(this.appId).then();
      });
    },

    toggleProcess(type, dialogShow) {
     this.showConfirmDialog = dialogShow ?? false;
     if (dialogShow) {
       this.chosenType = type;
     }
    }
  },

  computed: {
    ...mapState("app", ["appId"]),

    cardText() {
      if (this.chosenType === 'next') {
        return 'Продолжить';
      } else if (this.chosenType === 'stop') {
        return 'Дубль';
      }

      return null;
    }
  },
};
</script>

<style lang="scss" scoped></style>
